module.exports = __webpack_public_path__ + "img/search-icon.cb315b69.svg";